export enum GcpContractVehicleEnum {
  GCM = 'Google Cloud MarketPlace',
  PARTNER_CENTER = 'Partner Contract',
  NOT_KNOWN = 'Not known at this time',
}
